<template>
  <a-form-model
    class="part form task"
    ref="taskForm"
    :model="task"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :submit="onSubmit"
  >
    <a-form-model-item label="Urgent Task" prop="urgent">
      <a-switch v-model="task.urgent" />
    </a-form-model-item>

    <a-form-model-item label="Task name" prop="name">
      <a-input v-model="task.name" placeholder="Name of the task" />
    </a-form-model-item>

    <a-form-model-item label="Participants" prop="participants">
      <a-select mode="multiple" v-model="task.participants" placeholder="Please select the participants">
        <a-select-option v-for="staff in staffs" :key="staff._id" :value="staff._id">
          {{ staff.display_name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>

    <a-form-model-item label="Due date" prop="deadline">
      <a-date-picker v-model="task.deadline" show-time type="date" placeholder="Pick a deadline" style="width: 100%" />
    </a-form-model-item>

    <a-form-model-item label="Task type" prop="types">
      <a-checkbox-group v-model="task.types" class="checkboxes">
        <a-checkbox value="engineering" name="type"> Engineering </a-checkbox>
        <a-checkbox value="office" name="type"> Office </a-checkbox>
        <a-checkbox value="online" name="type"> Online </a-checkbox>
        <a-checkbox value="onsite" name="type"> On-Site </a-checkbox>
        <a-checkbox value="marketing" name="type"> Marketing </a-checkbox>
        <a-checkbox value="finance" name="type"> Finance </a-checkbox>
        <a-checkbox value="customer_service" name="type"> Customer Service </a-checkbox>
      </a-checkbox-group>
    </a-form-model-item>

    <a-form-model-item label="Description" prop="description">
      <a-input v-model="task.description" type="textarea" :rows="12" placeholder="Tell staff(s) what to do..." />
    </a-form-model-item>

    <!-- actions -->
    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="onSubmit"> Create </a-button>
      <a-button style="margin-left: 10px"> Cancel </a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
const KEY = 'CREATE_TASK'

export default {
  name: 'task-form',
  props: ['project'],
  data() {
    return {
      task: { project: this.project },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      rules: {
        name: [
          { required: true, message: 'Please input task name', trigger: 'blur' },
          { min: 3, max: 30, message: 'Length should be 3 to 30', trigger: 'blur' },
        ],
        participants: [
          {
            type: 'array',
            required: true,
            message: 'Please select at least one participant',
            trigger: 'change',
          },
        ],
        deadline: [{ required: true, message: 'Please pick a deadline', trigger: 'change' }],
        types: [
          {
            type: 'array',
            required: true,
            message: 'Please select at least one task type',
            trigger: 'change',
          },
        ],
        description: [{ required: true, message: 'Please input task description', trigger: 'blur' }],
      },
    }
  },
  computed: {
    staffs() {
      return this.$store.getters['staffs/data']('staffs')
    },
  },
  methods: {
    onSubmit() {
      this.$refs.taskForm.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.task)
        } else {
          console.log('task error submit!!')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.taskForm.resetFields()
    },
  },
  async created() {
    await this.$store.dispatch('staffs/fetchStaffs')
  },
  mounted() {
    if (this.project) this.task.project = this.project
  },
}
</script>

<style lang="scss" scoped>
.form.task {
  .checkboxes {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    justify-content: left;
    label {
      margin-left: unset;
    }
  }
}
</style>
